import { ErrorCode, PortalApiError } from '@afterpaytouch/portal-api/types'
import { Route } from '../../config/router'
import { TrackingEvent } from '../../model/monitoring'
import { CheckoutStatus } from '../../model/checkout'
import { setCheckoutStatus } from '../../state'
import { ErrorHandler, CheckoutErrorContext } from './types'

export const createCheckoutStartComplianceErrorHandler = (): ErrorHandler => ({
  canHandle: (errorCode: ErrorCode, error: PortalApiError): boolean => {
    return errorCode === ErrorCode.ComplianceDeclineSystemError
  },

  handle: async (errorCode: ErrorCode, error: PortalApiError, context: CheckoutErrorContext): Promise<Route> => {
    context.toast({
      message: context.t('summary:complianceDeclineSystemError'),
      kind: 'Failure',
    })

    context.dispatch(setCheckoutStatus(CheckoutStatus.Loaded))
    context.logEvent(TrackingEvent.CHECKOUT_DECLINED, {
      isRecoverableTerminalError: false,
      errorCode,
    })

    return context.hasPassword ? Route.ENTER_PASSWORD : Route.ENTER_EMAIL
  },
})
